import {AssetParent} from "./asset_Parent";

export class SoundAsset extends AssetParent {
    folderName = "Sounds"


    getWebPreviewImage(): string {
        return "assets/icons/EI.SoundBoard.png"
    }
}